import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true,
  pure: true
})
export class HighlightPipe implements PipeTransform {
  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll('\'', '&#39;');
  }

  transform(text: string, search: string): string {
    if (!search?.trim()) {
      return this.escapeHtml(text ?? '');
    }

    const safeText = text ?? '';
    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); 
    const regex = new RegExp(`(${escaped})`, 'gi');
    const highlighted = safeText.replace(regex, '<mark class="search-highlight">$1</mark>');
    return this.escapeHtml(highlighted).replace( 
      /&lt;mark class=&quot;search-highlight&quot;&gt;(.*?)&lt;\/mark&gt;/g,
      '<mark class="search-highlight">$1</mark>'
    );
  }
}
